import { Stack } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { DataProgramme } from '../../data/DataProgramme';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxAgence } from '../ComboBox/ComboBoxAgence';
import { ComboBoxRegion } from '../ComboBox/ComboBoxRegion';
import { EUIDialog } from '../EUI/EUIDialog';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import './FicheIdentification.css';

export class FicheProgrammeNomenclature extends Component {

    static defaultProps = {
        onAffichageSansPanel: false,
        onAffichePanelProgrammeNomenclature: false,
        onPeutChargerLeComposant: false,
        programme: {},
        /* --- */
        onChange: () => null, // méthode appelée si onAffichageSansPanel = true
        onEnregistrementFiche: () => null,
        onFermeFicheProgrammeNomenclature: () => null,
    };

    static defaultState = {
        programme: {},
        /* --- */
        onActiveBoutonEnregistrer: false,
    };

    _creationContent = () => {
        return <Fragment>
            <div name="divRegion">
                <ComboBoxRegion
                    filtreSurMonPerimetre
                    onChange={(event, option, index, value, item) => this._onMiseAJourChamp("programme", "idRegion", option.key)}
                    required
                    selectedKey={this.state.programme.idRegion}
                />
            </div>
            <div name="divAgence">
                <ComboBoxAgence
                    disabled={!(this.state.programme.idRegion > 0)}
                    filtreSurMonPerimetre
                    idRegion={this.state.programme.idRegion}
                    onChange={(event, option, index, value, item) => this._onMiseAJourChamp("programme", "idAgence", option.key)}
                    required
                    selectedKey={this.state.programme.idAgence}
                /></div>
        </Fragment>;
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheProgrammeNomenclature.defaultState };
    };

    _onInit = () => {
        this.setState({ ...FicheProgrammeNomenclature.defaultState });
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement du programme en cours"
        });

        const { idProgramme, idRegion, idAgence } = this.props.programme;
        DataProgramme._chargementProgramme(idProgramme, idRegion, idAgence)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const programme = responseFetch.reponseAPIobjet;
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, { programme }, this._onVerificationFormulaire);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });

    };

    _onEnregistrement = () => {

        this.setState({
            afficherDialog: false,
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Mise à jour du programme en cours"
        });

        const { idProgramme, idRegion, idAgence } = this.props.programme;
        const { programme } = this.state;

        DataProgramme._onEnregistrementProgrammeNomenclature(programme, idProgramme, idRegion, idAgence)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {});

                    this.props.onEnregistrementFiche(objetData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });

    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheProgrammeNomenclature();
    };

    _onOpen = () => {
        const { programme } = this.props;
        if (!!programme && !!programme.idProgramme && !!programme.idRegion && !!programme.idAgence) {
            this._chargementDonnees();
        }
    };

    _onRenderFooterContent = () => {
        const { onActiveBoutonEnregistrer } = this.state;
        return <div>
            <PrimaryButton name="btnEnregistrerProgrammeNomenclature" onClick={this._toggleDialog(true)} className="marginRight8px" disabled={!onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>
            <DefaultButton onClick={this._onAnnulation}>Annuler</DefaultButton>
        </div>;
    };

    _onMiseAJourChamp(nomObjet, nomPropriete, valeur) {
        if (nomPropriete == "idRegion") {
            let nomProprietes = [
                ["idRegion", valeur],
                ["idAgence", null]
            ];

            Scriba.state().setObjetProprietes(this, nomObjet, nomProprietes, this._onVerificationFormulaire);
        }
        else if (nomPropriete == "idAgence") {
            let nomProprietes = [
                ["idAgence", valeur]
            ];

            Scriba.state().setObjetProprietes(this, nomObjet, nomProprietes, this._onVerificationFormulaire);
        }

        if (this.props.onAffichageSansPanel) {
            this.props.onChange(nomPropriete, valeur);
        }
    };

    _onVerificationFormulaire = () => {
        Immocom.fiche()._validationFormulaire(this, "NomenclatureProgramme", this.state.programme, (this.state.programme.idProgramme > 0 ? "Modification" : "Création"));
    };

    _toggleDialog = (isOpen) => () => {
        this.setState({ afficherDialog: isOpen });
    };

    render = () => {

        const content = this._creationContent();

        if (this.props.onAffichageSansPanel) return content;
        else return <Panel
            isOpen={this.props.onAffichePanelProgrammeNomenclature}
            headerText="Nomenclature"
            type={PanelType.medium}
            onDismiss={this._onAnnulation}
            onOpen={this._onOpen}
            closeButtonAriaLabel="Fermer"
            onRenderFooterContent={this._onRenderFooterContent}
        >
            <Stack>

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                {content}

            </Stack>

            <EUIDialog
                buttons={[
                    <PrimaryButton name="btnConfirmProgrammeNomenclature" key="confirm" onClick={this._onEnregistrement} text="Confirmer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog(false)} text="Annuler" />
                ]}
                isOpen={this.state.afficherDialog}
                message="La mise à jour du périmètre du programme va également mettre à jour les périmètres des tranches travaux, opérations, mandats, indicateurs et bilans associés à ce programme. Cette mise à jour peut prendre jusqu'à plusieurs dizaines de minutes : souhaitez-vous continuer ?"
                onDismiss={this._toggleDialog(false)}
                titre="Avertissement"
            />

        </Panel>;

    };

}